module.exports = __webpack_public_path__ + "static/media/grofol.05f64efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/grofol.png
// module id = 1302
// module chunks = 3